import MessageQueue from '../../../../services/MessageQueue';
import IframeService from '../abstract/IframeService';

export default class FrameEventMessanger extends IframeService {
  private iframeRef: HTMLIFrameElement | null = null;

  constructor() {
    super('FrameEventMessanger');
  }

  public injectIframe(iframe: HTMLIFrameElement): void {
    this.iframeRef = iframe;
  }

  private getContentWindow(): Window | null {
    return this.iframeRef?.contentWindow ?? null;
  }

  public sendMessage(eventName: string, payload: any): void {
    const contentWindow = this.getContentWindow();
    if (!contentWindow) {
      return;
    }

    contentWindow.postMessage(
      {
        eventName,
        payload
      },
      '*'
    );
  }

  public async sendMessageAndWaitForResponse(
    eventName: string,
    payload: any
  ): Promise<any> {
    return new Promise((resolve) => {
      const dispose = MessageQueue.on(eventName + 'Success', (event) => {
        dispose();
        resolve(event.data.payload);
      });

      if (!this.iframeRef || !this.getContentWindow()) {
        dispose();
        resolve(null);
        return;
      }

      MessageQueue.fireInIframe(this.iframeRef, eventName, payload);
    });
  }
}
